export const PREFIX = 'packages.user_session_package';

export const BASE_LEGACY_PARAMS = {
    percentage: 100,
    ttl: -1
};
